import { authorizedGetRequest, postRequest } from "./httpClient";

// Tools page API surface (Issue 10 of the tool-definitions version-control PRD). Same
// draft/submit/publish/history/rollback shape as agentConfigApi.js, but for a practice's tool
// bundle (every apiFunction/cold_transfer/warm_transfer definition, versioned together as one
// atomic JSONB bundle) instead of the prompt bundle. No AI-suggestions gate and no live-pointer
// read here. The existing /api-integration page's own endpoints (used by
// ApiIntegration.js/FunctionModal.js) are untouched and unrelated to these.
export const createToolDefinitionsApi = ({ user }) => {
  const getToolDefinitionsDraft = async (practiceId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return authorizedGetRequest(
      user.token,
      `/api/toolDefinitions/draft/${resolvedPracticeId}`,
    );
  };

  const saveToolDefinitionsDraft = async (practiceId, bundle) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return postRequest(
      user.token,
      `/api/toolDefinitions/draft/${resolvedPracticeId}`,
      { bundle: bundle || {} },
    );
  };

  const submitToolDefinitionsDraft = async (practiceId, bundle) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return postRequest(
      user.token,
      `/api/toolDefinitions/submit/${resolvedPracticeId}`,
      { bundle: bundle || {} },
    );
  };

  const getSubmittedToolDefinitions = async (practiceId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return authorizedGetRequest(
      user.token,
      `/api/toolDefinitions/submitted/${resolvedPracticeId}`,
    );
  };

  const publishToolDefinitionsDraft = async (practiceId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return postRequest(
      user.token,
      `/api/toolDefinitions/publish/${resolvedPracticeId}`,
      {},
    );
  };

  const getToolDefinitionsHistory = async (practiceId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return authorizedGetRequest(
      user.token,
      `/api/toolDefinitions/history/${resolvedPracticeId}`,
    );
  };

  const rollbackToolDefinitionsVersion = async (practiceId, versionId) => {
    const resolvedPracticeId = Number.parseInt(practiceId, 10);
    if (!resolvedPracticeId) {
      throw new Error("PracticeId is required");
    }

    return postRequest(
      user.token,
      `/api/toolDefinitions/rollback/${resolvedPracticeId}`,
      { versionId },
    );
  };

  return {
    getToolDefinitionsDraft,
    saveToolDefinitionsDraft,
    submitToolDefinitionsDraft,
    getSubmittedToolDefinitions,
    publishToolDefinitionsDraft,
    getToolDefinitionsHistory,
    rollbackToolDefinitionsVersion,
  };
};
